//import App from './componentes_basicos/ItensMenuTela.svelte'; 
import App from './App.svelte';  
//import App from './Telas/Corrida/Vdot.svelte'; 
const app = new App({
    target: document.getElementById("app"),
});
export default app;     